<template>
  <section class="mapContent posire">
    <baidu-map
        class="map"
        :scroll-wheel-zoom="true"
        :center="center"
        :zoom="zoom"
        @ready="renderMap"
    >
      <!--【2022042201】轨迹线路渲染  --By liuyanming-->
      <bm-polyline :path="pointData" stroke-color="blue" :stroke-opacity="0.5" :stroke-weight="3"
                   :editing="false"></bm-polyline>
      <!--【2022042201】车辆轨迹移动--暂时不用   --By liuyanming-->
      <bml-lushu
          :path="pointData"
          :play="true"
          :speed="500"
          :autoView="true"
          :infoWindow="false"
          :rotation="true"
          :icon="icon">
      </bml-lushu>
      <bm-view class="map"/>
      <slot/>
    </baidu-map>
  </section>
</template>

<script>
// 【2022042101】处理地图渲染慢的问题   --By liuyanming
import mapIcon from 'images/mapIcon.png';
import {BmlLushu} from 'vue-baidu-map';

export default {
  components: {
    BmlLushu,
  },
  data () {
    return {
      BMap: null,
      map: null,
      center: {lng: 0, lat: 0},
      zoom: 3,
      pointDescVisible: false,
      markerPoint: null,
      markerPointAddress: '',
      trackData: null,
      pointData: [],
      showNewMap: false,
      icon: {
        url: 'http://api.map.baidu.com/library/LuShu/1.2/examples/car.png',
        size: {width: 52, height: 26},
        opts: {anchor: {width: 27, height: 13}},
      },
    };
  },
  methods: {
    renderMap ({BMap, map}) { // 地图渲染
      this.BMap = BMap;
      this.map = map;
      this.markerPoint = this.center;
      this.center.lng = 116.404;
      this.center.lat = 39.915;
      this.zoom = 15;
      if (this.trackData) {
        this.setTrack(this.trackData);
      }
    },
    createStartMarket (lng, lat) {
      try {
        // if (!this.showNewMap) {
        var icon = new this.BMap.Icon(mapIcon, new this.BMap.Size(33, 42), {
          offset: new this.BMap.Size(33, 42),
          imageOffset: new this.BMap.Size(-60, 0),
        });
        // }
        return this.createMarket(lng, lat, icon);
      } catch (error) {
        console.error(error);
      }
      return null;
    },
    createEndMarket (lng, lat) {
      try {
        // if (!this.showNewMap) {
        var icon = new this.BMap.Icon(mapIcon, new this.BMap.Size(33, 42), {
          offset: new this.BMap.Size(33, 42),
          imageOffset: new this.BMap.Size(-30, 0),
        });
        // }
        return this.createMarket(lng, lat, icon);
      } catch (error) {
        console.error(error);
      }

      return null;
    },
    createMiddleMarket (lng, lat) {
      try {
        if (!this.showNewMap) {
          var icon = new this.BMap.Icon(mapIcon, new this.BMap.Size(33, 42), {
            offset: new this.BMap.Size(33, 42),
            imageOffset: new this.BMap.Size(0, 0),
          });
          return this.createMarket(lng, lat, icon);
        }
      } catch (error) {
        console.error(error);
      }
    },
    getDriverRoute (map, startPoint, endPoint, wayPoints) {
      try {
        var driving = new this.BMap.DrivingRoute(map, {
          renderOptions: {map: map, autoViewport: true},
          onMarkersSet: function (routes) {
            map.removeOverlay(routes[0].marker); // 删除起点
            map.removeOverlay(routes[1].marker);// 删除终点
          },
        });
        if (wayPoints && wayPoints.length > 0) {
          driving.search(startPoint, endPoint, {waypoints: wayPoints});
        } else {
          driving.search(startPoint, endPoint);
        }
        return driving;
      } catch (error) {
        console.error(error);
      }
    },
    getPoint (lng, lat) {
      try {
        return new this.BMap.Point(lng, lat);
      } catch (error) {
        console.error(error);
      }
    },
    createMarket (lng, lat, icon) {
      try {
        var pt = this.getPoint(lng, lat);
        var marker = new this.BMap.Marker(pt, {icon: icon});
        // map.addOverlay(marker);
        return marker;
      } catch (error) {
        console.error(error);
      }
    },

    async setTrack (data) {
      if (this.showNewMap) {
        this.map.clearOverlays();
        this.pointData = [];
      }
      this.trackData = data;
      if (!this.BMap) {
        return;
      }
      var driving = new this.BMap.DrivingRoute(this.map, {
        renderOptions: {
          map: this.map,
          autoViewport: true,
        },
      });
      if (data && data.items.length >= 2) {
        var wayPoints = data.items;
        var startPoint = this.getPoint(wayPoints[0].eand, wayPoints[0].nand);
        var endPoint = this.getPoint(wayPoints[wayPoints.length - 1].eand, wayPoints[wayPoints.length - 1].nand);

        // 起点标注
        this.map.addOverlay(this.createStartMarket(wayPoints[0].eand, wayPoints[0].nand));
        // 终点标注
        this.map.addOverlay(this.createEndMarket(wayPoints[wayPoints.length - 1].eand, wayPoints[wayPoints.length - 1].nand));
        // 经停点标注
        for (let i = 1; i < wayPoints.length - 1; i++) {
          this.map.addOverlay(this.createMiddleMarket(wayPoints[i].eand, wayPoints[i].nand));
          var middlePoint = this.getPoint(wayPoints[i].eand, wayPoints[i].nand);
          this.map.addOverlay(new this.BMap.Label('经停点' + i, { position: middlePoint }));
        }
        // if (!this.showNewMap) {
        //   var driver;
        //   for (let i = 0; i < wayPoints.length - 1; i++) {
        //     if (!wayPoints[i].eand || wayPoints[i].eand <= 0 || !wayPoints[i].nand || wayPoints[i].nand <= 0) {
        //       continue;
        //     }
        //     if (!wayPoints[i + 1].eand || wayPoints[i + 1].eand <= 0 || !wayPoints[i + 1].nand || wayPoints[i + 1].nand <= 0) {
        //       continue;
        //     }
        //     startPoint = this.getPoint(wayPoints[i].eand, wayPoints[i].nand);
        //     endPoint = this.getPoint(wayPoints[i + 1].eand, wayPoints[i + 1].nand);
        //     if (!driver) {
        //       driving = this.getDriverRoute(this.map, startPoint, endPoint);
        //     } else {
        //       driving.search(startPoint, endPoint);
        //     }
        //     // if (i > 0) {
        //     //   this.map.addOverlay(new this.BMap.Label('经停点' + i, {position: startPoint}));
        //     // }
        //   }
        // } else {
        var point = [];
        for (var i = 0; i < wayPoints.length; i++) {
          point.push(this.getPoint(wayPoints[i].eand, wayPoints[i].nand));
        }
        this.pointData = point;
        // }
        // var driver;
        // for (let i = 0; i < wayPoints.length - 1; i++) {
        //   if (!wayPoints[i].eand || wayPoints[i].eand <= 0 || !wayPoints[i].nand || wayPoints[i].nand <= 0) {
        //     continue;
        //   }
        //   if (!wayPoints[i + 1].eand || wayPoints[i + 1].eand <= 0 || !wayPoints[i + 1].nand || wayPoints[i + 1].nand <= 0) {
        //     continue;
        //   }
        //   startPoint = this.getPoint(wayPoints[i].eand, wayPoints[i].nand);
        //   endPoint = this.getPoint(wayPoints[i + 1].eand, wayPoints[i + 1].nand);
        //   if (!driver) {
        //     driving = this.getDriverRoute(this.map, startPoint, endPoint);
        //   } else {
        //     driving.search(startPoint, endPoint);
        //   }
        //   if (i > 0) {
        //     this.map.addOverlay(new this.BMap.Label('经停点' + i, { position: startPoint }));
        //   }
        // }
      }
    },
  },
  mounted () {
    // 【2022051201】判断当前的页面是不是从轨迹查询菜单点进去的，是就更换地址渲染方式   --By liuyanming
    this.$route.path == '/manage/operate/track/track' ? this.showNewMap = true : this.showNewMap = false;
  },
};
</script>

<style scoped lang="scss">
.mapContent {
  padding-bottom: 32px;

  .map {
    width: 100%;
    height: 500px;
  }
}
</style>
